import React from 'react';
import 'antd/dist/antd.css';
import { Switch, Route, BrowserRouter } from 'react-router-dom';
// import Header from './entails/header';
// import Foot from './entails/foot';
import Home from './pages/home';
import Register from './pages/register';

const App = () => {
	const Router = () => {
		return (
			<Switch>
				<Route exact path="/register" component={Register} />
				<Route exact path="/" component={Home} />
				<Route component={Home} />
			</Switch>
		);
	};

	// console.log(
	// 	'DateTime.now().toMillis()',
	// 	DateTime.fromISO('2022-01-07T08:30:00').toMillis(),
	// );

	return (
		<BrowserRouter>
			<Router />
		</BrowserRouter>
	);
	// return DateTime.now().toMillis() < 1641544200000 ? (
	// ) : null;
};

export default App;
